import Tooltip from 'components/UI/Tooltip';
import { FC, ReactNode } from 'react';
import {
  Root,
  Content,
  Image,
  ValueContent,
  ClockContent,
  DesiredIconWrapper,
} from './styled';
import Copy from 'assets/vectors/copy.svg';
import IconButton from 'components/UI/IconButton';
import clockIcon from 'assets/vectors/clock.svg';
import { format } from 'date-fns';
import desiredIcon from 'assets/vectors/desire.svg';
import { DesiredValue } from 'models';
import { useIntl } from 'react-intl';
type Props = {
  children: ReactNode;
  active: boolean;
  value?: string;
  title?: string;
  modified?: number;
  desired?: DesiredValue;
};
// 36 to make a UUID fit. If longer tool tip used
const maxValueLength = 36;

const AccordionContent: FC<Props> = ({
  children,
  active,
  value,
  title,
  desired,
  modified,
}) => {
  const intl = useIntl();
  if (!active) {
    return null;
  }
  if (value) {
    const longValue = value.length > maxValueLength;
    return (
      <Content>
        <div>{title}</div>
        <ValueContent>
          {longValue && (
            <Tooltip paragraph={value}>
              {value.substring(0, 15).concat('...')}
              <IconButton
                onClick={() => navigator.clipboard.writeText(value)}
                data-testid="copy-button"
              >
                <Image src={Copy} alt="copy" />
              </IconButton>
            </Tooltip>
          )}
          {!longValue && <div>{value}</div>}
          {modified && (
            <ClockContent>
              <Tooltip
                paragraph={`Modified: ${format(
                  Number(modified),
                  'yyyy-MM-dd HH:mm:ss'
                )}`}
              >
                <IconButton>
                  <Image src={clockIcon} alt="modified" />
                </IconButton>
              </Tooltip>
            </ClockContent>
          )}
          <DesiredIconWrapper>
            {desired && (
              <Tooltip
                paragraph={`${intl.formatMessage({
                  id: 'connectivity.desired_value',
                })}: ${desired?.value}
        ${intl.formatMessage({
          id: 'connectivity.desired_status',
        })}: ${
                  typeof desired?.failed === 'number' && desired.failed > 15
                    ? 'Failed'
                    : 'Active'
                }
        ${intl.formatMessage({ id: 'connectivity.desired_set_by' })}: ${
                  desired?.setBy || 'N/A'
                }`}
              >
                <IconButton>
                  <Image src={desiredIcon} alt="Desired" />
                </IconButton>
              </Tooltip>
            )}
          </DesiredIconWrapper>
        </ValueContent>
      </Content>
    );
  }
  return <Root>{children}</Root>;
};

export default AccordionContent;
